import gql from 'graphql-tag';
import React from 'react';
import { Query } from '@apollo/client/react/components';

import { Icon } from '../../../../../../components/Icon';
import { IconButton } from '../../../../../../components/IconButton';
import { UnreadCounter as UnseenChatCounter } from '../../../UnreadCounter/UnreadCounter';
import { GetUnseenChatCountQuery as GetUnseenChatCount } from './__generated__/GetUnseenChatCountQuery';
import SetLastSeenAtMutation, { UNSEEN_CHAT_QUERY } from './SetLastSeenAtMutation';

export const UNSEEN_CHAT_COUNT_SUBSCRIPTION = gql`
    subscription GetUnseenChatCountSubscription {
        unseenChatCount
    }
`;

function onMessagesInboxRoute() {
    return Boolean(window.location.pathname.match(/\/messages[/0-9]*$/));
}

export class OnsiteMessagesIcon extends React.Component {
    render() {
        return (
            <SetLastSeenAtMutation>
                {({ setLastSeenAt }) => (
                    <IconButton onClick={setLastSeenAt}>
                        {!onMessagesInboxRoute() && (
                            <Query<GetUnseenChatCount> query={UNSEEN_CHAT_QUERY}>
                                {({ data, subscribeToMore, error }) => {
                                    if (error || !data) return null;

                                    return (
                                        <UnseenChatCounter
                                            subscribeToMore={() =>
                                                subscribeToMore({
                                                    document: UNSEEN_CHAT_COUNT_SUBSCRIPTION,
                                                    updateQuery: (
                                                        prev: GetUnseenChatCount,
                                                        {
                                                            subscriptionData,
                                                        }: {
                                                            subscriptionData: {
                                                                data: GetUnseenChatCount;
                                                            };
                                                        }
                                                    ) => {
                                                        if (!subscriptionData.data) return prev;
                                                        const unseenChatCount =
                                                            subscriptionData.data.unseenChatCount;

                                                        return Object.assign({}, prev, {
                                                            unseenChatCount,
                                                        });
                                                    },
                                                })
                                            }
                                            unreadCount={data.unseenChatCount}
                                        />
                                    );
                                }}
                            </Query>
                        )}
                        <Icon type="mail-4" variations={['inline']} />
                    </IconButton>
                )}
            </SetLastSeenAtMutation>
        );
    }
}

export default OnsiteMessagesIcon;
